class Base {
  constructor(storage, rootComponent) {
    this.storage = storage
    this.rootComponent = rootComponent
    this.cache = {}
  }
  
  set(key, value) {
    this.storage.setItem(key, JSON.stringify(value))
    this.cache[key] = value
    return this
  }

  get(key) {
    if (key in this.cache) return this.cache[key]
    let value = JSON.parse(this.storage.getItem(key))
    this.cache[key] = value
    return value
  }

  remove(key) {
    this.storage.removeItem(key)
    delete this.cache[key]
    return this
  }

  thenUpdate(component) {
    (component || this.rootComponent).forceUpdate()
  }
}

export const wrapStorage = (storage) => {
  return new Proxy(storage, {
    get: (target, name) => {
      if (target[name] !== undefined) {
        return target[name]
      }
      return target.get(name)
    },
    set: (target, name, value) => {
      target.set(name, value)
      if (target[name]) {
        return false
      }
      return true
    },
    deleteProperty: (target, name) => {
      return target.remove(name)
    },
  })
}

export default Base



// WEBPACK FOOTER //
// ./src/Persistence/Base.js